export default __webpack_public_path__ + "static/media/broom.94cafbcd.png";